
export default class ReportingService {
  constructor(server) {
    this.server = server;
  }

  load() {
    return this.server('reporting-load');
  }

  getQueueSize() {
    return this.server("get-queue-size");
  }

  exportOpm(dateFrom, dateTo, energyType, language, extUis) {
    // export-opm-ee, export-opm-zp
    const method = 'export-opm-' + energyType;
    this.server.asForm(method, {
      dateFrom: dateFrom,
      dateTo: dateTo,
      language: language,
      extUis: extUis,
    });
  }

  exportMeasurement(
    dateFrom,
    dateTo,
    energyType,
    language,
    typm,
    profileRole,
    opmType,
    dataType,
    dataPeriod,
    supplierCode,
    dataProviderCode,
    extUis,
    note
  ) {
    const params = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      language: language,
      typm: typm,
      profileRole: profileRole,
      opmType: opmType,
      dataType: dataType,
      dataPeriod: dataPeriod,
      extUis: extUis,
      note: note
    };

    if (energyType === 'ee') {
      params['supplierEan'] = supplierCode;
      params['dataProviderEan'] = dataProviderCode;
    } else {
      params['supplierEic'] = supplierCode;
      params['gridId'] = dataProviderCode;
    }

    const method = 'export-measurement-' + energyType;  // export-measurement-ee, export-measurement-zp
    this.server.asForm(method, params);
  }
}



// WEBPACK FOOTER //
// ./src/Reporting/ReportingService.js